(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.MarketPlace.ElevateLifeAssets.Vault",
                {
                    url: "/Vault",
                    component: "e4lvault",
                    PageTitle: "Elevate for Life Vault"
                });
        }
    ]);

    app.component("e4lvault",
        {
            templateUrl: "App/Tools/MarketPlace/ElevateLifeAssets/Vault/Vault.html",
            controller: e4LVaultCtrl,
            bindings: {
            }
        });

    e4LVaultCtrl.$inject = ["$timeout", "$state", "$mdDialog", "$filter", "ssoApi"];

    function e4LVaultCtrl($timeout, $state, $mdDialog, $filter, ssoApi) {
        var $ctrl = this;


        $ctrl.vault = [
            {
                GroupID: 0, Event: "Elevate U", Date: "March 1-3, 2017", Location: "Phoenix, AZ", Speakers: [
                    {
                        Name: "Eszylfie Taylor ", Title: "", Videos: [
                            {
                                Name: "The Opportunity – The Close", WistiaURL: "wistia_async_45v19ybjfc", Date: "03-17-2017",
                            },
                            {
                                Name: "The Approach – The Fact Find", WistiaURL: "wistia_async_7i1w4e7mxk", Date: "03-16-2017",
                            },
                            {
                                Name: "Tax Diversification", WistiaURL: "wistia_async_2bqmwdwjvc", Date: "03-16-2017",
                            },
                            {
                                Name: "Planned Giving – Tools and Tips for Nonprofits", WistiaURL: "wistia_async_h1nh8tcnu2", Date: "03-16-2017",
                            },
                        ]
                    }
                ]
            },
            {
                GroupID: 1, Event: "Elevate U", Date: "June 26-28, 2017", Location: "Charlotte, NC", Speakers: [
                    {
                        Name: "Crystal Langdon", Title: "", Videos: [
                            {
                                Name: "MARKETING: CLARIFY YOUR MESSAGE", WistiaURL: "wistia_async_mkogz7axsr", Date: "",
                            },
                            {
                                Name: "OUR FOUR MARKETING CHANNELS", WistiaURL: "wistia_async_dr59bvulcs ", Date: "",
                            },
                            {
                                Name: "WHY LIFE?", WistiaURL: "wistia_async_bxurws1f8g", Date: "",
                            },
                            {
                                Name: "CLIENT PRESENTATION: PART 1", WistiaURL: "wistia_async_k2cb02iqbe", Date: "",
                            },
                            {
                                Name: "CLIENT PRESENTATION: PART 2", WistiaURL: "wistia_async_wn729w654f", Date: "",
                            },
                        ]
                    }
                ]
            },
        ]

    }



})(window.app);